/**
 * Opt a request out of the app-global 401/403 toast in `App.react.js`.
 *
 * That toast ("It looks like you don't have access to perform this action") reads as a failed
 * action, so it is wrong for a page whose own answer to the 403 *is* the access state — opening
 * an unlicensed folder already renders the upgrade modal.
 *
 * `genericMandarkRequest` takes a `suppressGlobalErrorToast` option, but the resource-builder
 * path (`getResourcePromise`) has none, and threading one through the interest registry would
 * bake the flag into a cached `requestFunction` that later callers of the same endpoint reuse.
 */
let depth = 0;

export const isSuppressingAccessToasts = (): boolean => depth > 0;

/**
 * Silences the global 401/403 toast for the duration of `request`. Concurrent unrelated
 * failures inside that window are silenced too, so keep the wrapped call narrow.
 */
export const withSuppressedAccessToasts = async <T>(request: () => Promise<T>): Promise<T> => {
  depth += 1;
  try {
    return await request();
  } finally {
    depth -= 1;
  }
};
